export default {
    route: false,
    drawer: false,
    loading: false,
    page_loading: false,
    alert: null,
    user: null,
    authorization: null,
    mails: [],
    unread: 0
}
